import { combineReducers, CombinedState, AnyAction, Reducer } from 'redux';
import auth, { AuthState } from './slices/auth';
import base, { BaseState } from './slices/base';
import locale, { LocaleState } from './slices/locale/localeSlice';
import theme, { ThemeState } from './slices/theme/themeSlice';
// Removed RtkQueryService - landing pages use TanStack React Query instead

export type RootState = CombinedState<{
	auth: CombinedState<AuthState>;
	base: CombinedState<BaseState>;
	locale: LocaleState;
	theme: ThemeState;
}>;

export interface AsyncReducers {
	[key: string]: Reducer<any, AnyAction>;
}

const staticReducers = {
	auth,
	base,
	locale,
	theme,
};

const rootReducer = (asyncReducers?: AsyncReducers) => (state: RootState, action: AnyAction) => {
	const combinedReducer = combineReducers({
		...staticReducers,
		...asyncReducers,
	});
	return combinedReducer(state, action);
};

export default rootReducer;